import { createApp } from 'vue';
import App from './App.vue';
import axios from 'axios';
import router from './router/index';
import store from './store/store'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import './main.css';
import FontAwesomeIcon from './components/fontawesomeicons';

import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import VueTelInput from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import Pagination from './components/Pagination.vue';
import SkeletonLoader from './components/SkeletonLoader.vue';

import PrintButtonHeader from './components/PrintButtonHeader.vue';

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VNum from "v3-num";
// import { isSubscribed } from './isSubscribed';
import Flutterwave from 'flutterwave-vue3'
import CanvasJSChart from '@canvasjs/vue-charts';
import VueGoogleCharts from 'vue-google-charts'
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;
window.Echo = new Echo({
  broadcaster: 'pusher',
  key:         process.env.VUE_APP_PUSHER_APP_KEY,
  cluster:     process.env.VUE_APP_PUSHER_APP_CLUSTER,
  forceTLS:    true,
  authEndpoint: `${process.env.VUE_APP_API_HOST || 'https://admin.mapiibs.co.uk'}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  },
});

// window.Echo = new Echo({
//   broadcaster:     'reverb',
//   key:             process.env.VUE_APP_REVERB_APP_KEY || 'inventflux-key',
//   wsHost:          process.env.VUE_APP_REVERB_HOST    || '127.0.0.1',
//   wsPort:          parseInt(process.env.VUE_APP_REVERB_PORT || '8080'),
//   wssPort:         parseInt(process.env.VUE_APP_REVERB_PORT || '8080'),
//   forceTLS:        (process.env.VUE_APP_REVERB_SCHEME || 'http') === 'https',
//   enabledTransports: ['ws', 'wss'],
//   authEndpoint:    'http://127.0.0.1:8000/broadcasting/auth',
//   auth: {
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem('token')}`,
//     },
//   },
// });

// axios.defaults.baseURL = 'http://127.0.0.1:8000/api/';
// export default {
//     hostName: 'http://127.0.0.1:8000/'
// }

axios.defaults.baseURL = 'https://admin.mapiibs.co.uk/api/';
export default {
    hostName : 'https://admin.mapiibs.co.uk/'
}

// axios.defaults.baseURL = 'https://test.admin.inventflux.com/api/';
// export default {
//     hostName : 'https://test.admin.inventflux.com/'
// }

// Paths that must NOT get the company-code prefix injected
const PUBLIC_PATHS = [
  // Auth
  '/login', '/login-web', '/register', '/register-web',
  '/forgot-password', '/reset-password', '/verify-email',
  '/send-verification-link', '/resend-verification',
  // Pricing & payments
  '/pricing-plans', '/subscription/pricing-plans',
  '/payment-channels', '/payment/channels',
  '/payment/initiate-stripe',
  '/payment/verify-flutterwave-payment',
  '/payment/verify-paystack-payment',
  '/payment/verify-stripe-payment',
  '/subscription-invoice',
  // Misc public
  '/send-enquiry', '/send-newsletter',
  '/get-visitor-country',
  '/employees-invite',
  '/public/careers',
  // Vendor portal (stateless token auth — not company-scoped like the main app)
  '/vendor',
  // Blog (public CMS pages — no company context needed)
  '/admin/active-blog', '/admin/active-blog-categories', '/admin/blog-featured',
  '/admin/blog-by-category', '/admin/blog-detail', '/admin/blog-search', '/admin/blog-comment',
  // FAQ
  '/admin/active-faq',
  // Project setup & public content (used by subscribe page, about page, and public contact modals)
  '/admin/fetchProjectSetup', '/admin/active-features',
  // Online invoice payment (public — no auth or tenant context)
  '/invoice/online-detail', '/gateway/details', '/invoice/record-online-payment',
  // CRM public survey links (token-based, no auth or tenant scoping needed)
  '/public/crm/surveys',
  // Visitor check-in public kiosk (unauthenticated, tenant resolved via URL params)
  'public/visitors',
  // Quote request form (public contact form — no company context)
  'request-quote',
];

// Redirect to the subscription page when the backend returns 402 (subscription expired/missing).
// The message is stored in sessionStorage so the subscription page can display it as a banner.
// Guard: don't redirect if already on a subscription-related page — doing so would
// trap users on the subscribe/upgrade page if any ancillary call returns 402.
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 402 && error.response?.data?.code === 'SUBSCRIPTION_REQUIRED') {
      const currentPath = router.currentRoute.value?.path ?? '';
      const onSubscriptionPage = currentPath.includes('/subscription') || currentPath.includes('/subscribe');
      if (!onSubscriptionPage) {
        sessionStorage.setItem('subscription_notice', error.response.data.message || 'Please renew your subscription to continue.');
        router.push('/subscription-plan');
      }
    }
    return Promise.reject(error);
  }
);

// Inject the company code into every authenticated API call so the
// backend can resolve the correct tenant via URL (ResolveCompanyByCode).
axios.interceptors.request.use(config => {
  const raw  = localStorage.getItem('companyCode');
  // Guard against localStorage storing "null" / "undefined" as strings
  const code = raw && raw !== 'null' && raw !== 'undefined' ? raw : null;

  if (code) {
    const url = config.url || '';
    const isPublic = PUBLIC_PATHS.some(p => url === p || url.startsWith(p + '/') || url.startsWith(p + '?'));
    if (!isPublic) {
      // Normalise: strip leading slash then prepend code
      config.url = `/${code}/${url.replace(/^\//, '')}`;
    }
  }
  return config;
});

const options = {
    "timeout": 1900
};

axios.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`
const app = createApp(App);

app.use(router)
   .use(store)
   .use(VNum)
   .use(Flutterwave)
   .use(Toast, options)
   .use(VueLoading, { color: 'red' })
   .use(CanvasJSChart)
   .use(VueTelInput)
   .use(VueGoogleCharts)
   .component("font-awesome-icon", FontAwesomeIcon)
   .component("Pagination", Pagination)
   .component("PrintButtonHeader", PrintButtonHeader)
   .component("SkeletonLoader", SkeletonLoader)
   .component("Datepicker", Datepicker)
   .mount('#app');

// Build a company-scoped URL from a relative or absolute path.
// Used in templates as :to="$url('some-path')" or :to="$url(tab.to)".
app.config.globalProperties.$url = function (path) {
  const code = this.$route?.params?.companyCode || localStorage.getItem('companyCode') || '';
  if (!path || path === '#') return path;
  const p = String(path).replace(/^\//, '');
  return code ? `/${code}/${p}` : `/${p}`;
};

// Patch router.push / router.replace so that any programmatic navigation
// using a plain absolute path (e.g. router.push('/create-payroll')) is
// automatically prefixed with the current company code.
const _routerPush    = router.push.bind(router);
const _routerReplace = router.replace.bind(router);

const PUBLIC_ROUTE_PREFIXES = [
  '/home', '/auth', '/blog', '/contact', '/about', '/faq', '/pricing',
  '/search', '/payment-success', '/invite',
  '/privacy-policy', '/terms-and-conditions', '/cookie-policy',
  '/vendor',
];

function _prefixCode(location) {
  const raw  = localStorage.getItem('companyCode');
  const code = raw && raw !== 'null' && raw !== 'undefined' ? raw : null;
  if (!code || !location) return location;

  if (typeof location === 'string') {
    if (!location.startsWith('/')) return location;
    if (location.startsWith(`/${code}/`) || location === `/${code}`) return location;
    const isPublic = PUBLIC_ROUTE_PREFIXES.some(p => location === p || location.startsWith(p + '/') || location.startsWith(p + '?'));
    return isPublic ? location : `/${code}${location}`;
  }

  if (typeof location === 'object') {
    // { path: '/some-path' } — prefix the path
    if (location.path) {
      const fixed = _prefixCode(location.path);
      return fixed === location.path ? location : { ...location, path: fixed };
    }
    // { name: 'RouteName', params: { ... } } — add companyCode to params
    if (location.name) {
      const params = { companyCode: code, ...(location.params || {}) };
      return { ...location, params };
    }
  }

  return location;
}

router.push    = location => _routerPush(_prefixCode(location));
router.replace = location => _routerReplace(_prefixCode(location));

app.config.globalProperties.$filters = {
    formatMoney(n, currency = '') {
        return currency + parseFloat(n).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');

    }
}

app.config.globalProperties.$truncate = function (text, length = 50) {
  if (!text) return ''
  return text.length > length ? text.slice(0, length) + '...' : text
}



router.beforeEach((to, from, next) => {
    let currentUser = store.state.getLoggedInUser
    if (to.matched.some(record => record.meta.requiresSubscription) && !currentUser?.has_subscribed) {
        // next({ name: "Subscribe" })
        next();

        // isSubscribed.access(to, next, currentUser)
    } else {
        next();
    }
})